import { render, staticRenderFns } from "./termination.vue?vue&type=template&id=c0c91548&scoped=true"
import script from "./termination.vue?vue&type=script&lang=js"
export * from "./termination.vue?vue&type=script&lang=js"
import style0 from "./termination.vue?vue&type=style&index=0&id=c0c91548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c91548",
  null
  
)

export default component.exports